
module.filter('dolRegion', function(dolRegionStates, dolRegionNames) {
    return function(state) {
        var num = dolRegionStates[state];
        if (num) {
            return ['DOL Region', num, '-', dolRegionNames[num - 1]]
                .join(' ');
        }
    };
});
